import React from 'react';

interface FacebookIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const FacebookIcon: React.FC<FacebookIconProps> = ({
  width = 20,
  height = 20,
  fill = '#0f0f0f',
}) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 20 20"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m12 11.5h2.5l1-4h-3.5v-2c0-1.03 0-2 2-2h1.5v-3.36c-.326-.0429999-1.557-.14-2.857-.14-2.715 0-4.643 1.657-4.643 4.7v2.8h-3v4h3v8.5h4z"
      fill={fill}
    />
  </svg>
);

export default FacebookIcon;
